import { render, staticRenderFns } from "./MyPip.vue?vue&type=template&id=1585b501&scoped=true&"
import script from "./MyPip.vue?vue&type=script&lang=js&"
export * from "./MyPip.vue?vue&type=script&lang=js&"
import style0 from "./MyPip.vue?vue&type=style&index=0&id=1585b501&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1585b501",
  null
  
)

export default component.exports